import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useUserStore } from '@/stores/user'
import { userApi, type UserDetailStat, type UserDetailUser } from '@/api/user'

export const useUserProfileStore = defineStore('userProfile', () => {
  const user = ref<Partial<UserDetailUser>>({})
  const stat = ref<Partial<UserDetailStat>>({})

  let inflight: Promise<boolean> | null = null

  const hasValidRefreshToken = () => {
    const userStore = useUserStore()
    const refreshToken = userStore.userInfo?.refreshToken || localStorage.getItem('refreshToken')
    return userStore.isLoggedIn && !!refreshToken
  }

  const reset = () => {
    inflight = null
    user.value = {}
    stat.value = {}
  }

  /** 已登录且刷新令牌有效时拉取当前用户信息；未登录不发请求 */
  const fetchDetail = async (): Promise<boolean> => {
    if (!hasValidRefreshToken()) {
      return false
    }
    if (inflight) {
      return inflight
    }

    inflight = (async () => {
      try {
        const res = await userApi.getUserDetail()
        if (!hasValidRefreshToken()) {
          return false
        }
        if (res?.code !== 0 || !res.data) {
          console.error('[userProfileStore] 查询当前用户信息失败:', res?.message)
          return false
        }
        user.value = res.data.user ?? {}
        stat.value = res.data.stat ?? {}
        return true
      } catch (error) {
        console.error('[userProfileStore] 查询当前用户信息失败:', error)
        return false
      } finally {
        inflight = null
      }
    })()

    return inflight
  }

  return {
    user,
    stat,
    fetchDetail,
    reset,
  }
})
